module.exports = __webpack_public_path__ + "img/webSite-5.7aaefb3a.png";